import React from "react";
import bannerBgImage from "../../assets/img/donatebg.png";

const DonateBanner = () => {
	return (
		<div
			className='relative bg-cover bg-center bg-no-repeat bg-fixed'
			style={{ backgroundImage: `url(${bannerBgImage})` }}>
			{/* Overlay */}
			<div className='bg-black/60'>
				<div className='max-w-[1440px] w-[90%] mx-auto lg:pt-40 sm:pt-32 pt-20 pb-16 text-center space-y-3'>
					<h1 className='lg:text-[72px]/[88px] text-[32px]/[31px] font-semibold text-white mb-4 lg:tracking-[-3px] tracking-[-1px]'>
						Help Make Healthcare
						<br /> Accessible
					</h1>
					<p className='w-full max-w-[850px] mx-auto lg:text-xl/[34px] text-base/5 text-white mb-8'>
						At SynergyCare Foundation, your donation helps bridge that gap. Your
						support ensures we can continue connecting underserved communities
						with essential healthcare services.
					</p>
				</div>
			</div>
		</div>
	);
};

export default DonateBanner;
